require('../modules/web.timers');
module.exports = require('../modules/_core');



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/web/timers.js
// module id = 852
// module chunks = 7